import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';


export const MyMProgressPartially = () => {
  return (
    <Box sx={{
      zIndex: 2147483647,
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(255, 255, 255, 0.38)",
      position: 'absolute',
    }}>
      <CircularProgress sx={{ position: 'absolute' }} />
    </Box>
  )
}